import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Overview from './components/Overview';
import GettingStarted from './components/GettingStarted';
import AppGuide from './components/AppGuide';
import Membership from './components/Membership';
import Troubleshoot from './components/Troubleshoot';
import AddressChange from './components/AddressChange';
import Safety from './components/Safety';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <GettingStarted />
        <AppGuide />
        <Membership />
        <Troubleshoot />
        <AddressChange />
        <Safety />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}